"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FerryPaymentHistoryResponse {
}
exports.default = FerryPaymentHistoryResponse;
//# sourceMappingURL=FerryPaymentHistoryResponse.js.map